export const  popularLocations = [
  {
    href: "/locations/los-angeles",
    name: "Los Angeles, CA"
  },
  {
    href: "/locations/san-francisco",
    name: "San Francisco, CA"
  },
  {
    href: "/locations/las-vegas",
    name: "Las Vegas, NV"
  },
  {
    href: "/locations/austin",
    name: "Austin, TX"
  },
  {
    href: "/locations/san-diego",
    name: "San Diego, CA"
  },
  {
    href: "/locations/phoenix",
    name: "Phoenix, AZ"
  },
  {
    href: "/locations/chicago",
    name: "Chicago, IL"
  },
  {
    href: "/locations/orlando",
    name: "Orlando, FL"
  },
  {
    href: "/locations/miami",
    name: "Miami, FL"
  },
  {
    href: "/locations/daytona-beach",
    name: "Daytona Beach, FL"
  },
  {
    href: "/locations/tampa",
    name: "Tampa, FL"
  },
  {
    href: "/locations/honolulu",
    name: "Honolulu, HI"
  }
]